export default __webpack_public_path__ + "static/media/bannerCrisBarrosMobile.f3313e21.svg";